<template>
  <div id="dialog-box" class="error-dialog">
    <div class="error-dialog-box">
      <h1 class="modal-header">{{ title }}</h1>
      <div class="modal-contents">
        <p class="modal-contents-error">{{ message }}</p>
        <p
          >Please share the keyword when referring to this error:<br /><code>{{ errorUuid }}</code>
        </p>
      </div>
      <div class="modal-footer">
        <a class="btn btn-default" @click="closeDialog">Close</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'error-dialog',
  props: {
    message: {
      default: 'An unexpected error occured!',
      type: String,
    },
    title: {
      default: 'Error',
      type: String,
    },
    errorUuid: {
      default: '',
      type: String,
    },
  },
})
export default class ErrorDialog extends Vue {
  /* Default empty state message */
  public message!: string;
  public $notify!: (title: string, message: string) => void;

  public closeDialog() {
    this.$emit('close-dialog');
  }
}
</script>

<style src="./error-dialog.component.scss" lang="scss"></style>
